module.exports = __webpack_public_path__ + "c40dad26d70391f11219602eaf0d8977.svg";